import { createFileRoute } from '@tanstack/react-router';

import VoiceSalesCallDetailPage from '../../views/dashboard-voice-sales/detail';

export const Route = createFileRoute('/dashboard/voice-sales/calls_/$callUuid')({
  component: VoiceSalesCallDetailPage,
});
